export default [
  {
    avatar: `${process.env.PUBLIC_URL}/img/11.png`,
    name: 'Peter Jackson',
    userName: 'littleOrc',
    post: 'Corcoran',
    messages: [
      {
        userName: 'littleOrc',
        message: 'Have a buyer that would be interested in getting a deal in this building, anyone ',
        date: new Date(2018, 3, 7, 10, 20, 0, 0),
      },
      {
        userName: 'dragonKing',
        message: 'Reasonably how possession shy way introduced age inquietude. Missed he engage no exeter of 🙏',
        date: new Date(2018, 3, 7, 10, 21, 0, 0),
      },
      {
        userName: 'littleOrc',
        message: 'Sales statistic.png',
        file: {
          preview: `${process.env.PUBLIC_URL}/img/landing/demos/default_light.png`,
          size: '(2,1 Mb)',
        },
        date: new Date(2018, 3, 7, 10, 22, 0, 0),
      },
      {
        userName: 'dragonKing',
        message: 'Hello. Sounds good, Thank you 👌',
        date: new Date(2018, 3, 7, 12, 12, 0, 0),
      },
      {
        userName: 'littleOrc',
        message: 'Eldest father can design tastes did joy settle. Roused future he ye an marked. Arose mr rapid '
        + 'in so vexed words. Gay welcome led add lasting chiefly say looking. ',
        date: new Date(2018, 3, 7, 12, 35, 0, 0),
      },
    ],
  },
  {
    avatar: `${process.env.PUBLIC_URL}/img/12.png`,
    name: 'Lora Melbourn',
    userName: 'dragon666',
    post: 'Douglas Ellimam',
    messages: [],
  },
  {
    avatar: `${process.env.PUBLIC_URL}/img/15.png`,
    name: 'Cathy Mew',
    userName: 'blackCat',
    post: 'Compass',
    messages: [
      {
        userName: 'dragonKing',
        message: 'Knowledge nay estimable questions repulsive daughters boy. Solicitude gay way unaffected '
        + 'expression for. His mistress ladyship required off horrible disposed rejoiced. Unpleasing pianoforte '
        + 'unreserved as oh he unpleasant no inquietude insipidity. ',
        date: new Date(2018, 3, 7, 10, 22, 0, 0),
      },
      {
        userName: 'blackCat',
        message: 'Solicitude gay way unaffected expression for?',
        date: new Date(2018, 3, 7, 12, 12, 0, 0),
      },
      {
        userName: 'dragonKing',
        message: 'Unpleasing pianoforte unreserved as oh he unpleasant no inquietude insipidity. ',
        date: new Date(2018, 3, 7, 12, 35, 0, 0),
      },
    ],
  },
  {
    avatar: `${process.env.PUBLIC_URL}/img/14.png`,
    name: 'Liza Orly',
    userName: 'lily',
    post: 'Halstead',
    messages: [
      {
        userName: 'dragonKing',
        message: 'Unpleasing pianoforte unreserved as oh he unpleasant no inquietude insipidity. ',
        date: new Date(2018, 3, 7, 12, 35, 0, 0),
      },
    ],
  },
  {
    avatar: `${process.env.PUBLIC_URL}/img/24_mail_ava.png`,
    name: 'Michael Bro',
    userName: 'bro',
    post: 'Brown Harris Stevens',
    messages: [
      {
        userName: 'bro',
        message: 'Unpleasing pianoforte unreserved as oh he unpleasant no inquietude insipidity. ',
        date: new Date(2018, 3, 7, 12, 35, 0, 0),
      },
      {
        userName: 'bro',
        message: 'Unpleasing pianoforte unreserved.',
        date: new Date(2018, 3, 7, 12, 35, 0, 0),
      },
    ],
  },
];
